/** @jsx jsx */
import { jsx } from '@emotion/core';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import get from 'lodash/get';
import defaultsDeep from 'lodash/defaultsDeep';
import truncate from 'lodash/truncate';
import Spacer from '../../ui/Spacer';
import CtaLink from '../../ui/CtaLink';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import { Container, Row, Column } from '../../../styles/Grid';
import {
  title,
  mediaTitle,
  mediaDescription,
  containerMarginCss,
  containerPaddingCss,
  articleContainerCss,
} from './index.styles';

export const defaultFields = {
  data: {
    datasource: {
      backgroundColor: {
        jss: {
          id: '',
          url: '',
          fields: {
            Value: {
              value: '',
            },
          },
        },
      },
      title: {
        jss: {
          value: '',
        },
      },
      relatedArticles: {
        targetItems: [
          {
            metaTitle: {
              jss: {
                value: '',
              },
            },
            metaDescription: {
              jss: {
                value: '',
              },
            },
            url: '',
          },
          {
            metaTitle: {
              jss: {
                value: '',
              },
            },
            metaDescription: {
              jss: {
                value: '',
              },
            },
            url: '',
          },
        ],
      },
    },
  },
};

class RelatedArticles extends SafePureComponent {
  safeRender() {
    const { fields: fieldsProp, t } = this.props;
    const fields = defaultsDeep(fieldsProp, defaultFields);
    const queryData = get(fields, 'data.datasource', {});
    const articles = get(queryData, 'relatedArticles.targetItems', {});

    return (
      <Spacer
        backgroundColor={queryData.backgroundColor.jss}
        marginCss={containerMarginCss}
        paddingCss={containerPaddingCss}
      >
        <Container>
          <Row>
            <Column cols={{ sm: 6, md: 2, lg: 2 }} offset={{ lg: 1 }}>
              <h2 css={title}>
                <Text field={queryData.title.jss} />
              </h2>
            </Column>
            <Column cols={{ sm: 6, md: 5, lg: 8 }}>
              <Row>
                {articles.map((listItem, index) => (
                  <Column
                    key={`related-article-${index}`}
                    cols={{ sm: 6, md: 8, lg: 6 }}
                  >
                    <article css={articleContainerCss}>
                      <h3 css={mediaTitle}>
                        <Text field={listItem.metaTitle.jss} editable={false} />
                      </h3>
                      <p css={mediaDescription}>
                        {truncate(listItem.metaDescription.jss.value, {
                          length: 110,
                        })}
                      </p>
                      <CtaLink href={listItem.url} text={t('ReadArticle')} />
                    </article>
                  </Column>
                ))}
              </Row>
            </Column>
          </Row>
        </Container>
      </Spacer>
    );
  }
}

RelatedArticles.displayName = 'RelatedArticles';

RelatedArticles.defaultProps = {
  fields: defaultFields,
};

RelatedArticles.propTypes = {
  fields: PropTypes.shape({
    data: PropTypes.shape({
      datasource: PropTypes.shape({
        backgroundColor: PropTypes.shape({
          jss: PropTypes.shape({
            fields: PropTypes.shape({
              Value: PropTypes.shape({
                value: PropTypes.string.isRequired,
              }),
            }),
          }),
        }),
        title: PropTypes.shape({
          jss: PropTypes.shape({
            value: PropTypes.string.isRequired,
          }),
        }),
        relatedArticles: PropTypes.shape({
          targetItems: PropTypes.arrayOf(
            PropTypes.shape({
              metaTitle: PropTypes.shape({
                jss: PropTypes.shape({
                  value: PropTypes.string.isRequired,
                }),
              }),
              url: PropTypes.string.isRequired,
              metaDescription: PropTypes.shape({
                jss: PropTypes.shape({
                  value: PropTypes.string.isRequired,
                }),
              }),
            }),
          ),
        }),
      }),
    }),
  }),
};

export default withNamespaces()(RelatedArticles);
